module.exports = __webpack_public_path__ + "static/img/animacion_background.f61526d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading/animacion_background.jpg
// module id = t91I
// module chunks = 3